import { useState, useEffect } from 'react';
import {
  AccountBalanceAccountType,
  AccountBalanceEntriesResponse,
  AccountBalanceEntryEntryTypeEnum,
  EntryType,
  InternalOptionsApi,
  PaymentMethodId,
} from '@commerce-payment-webcomponents/sdk';
import { QuantityContainer } from '../internal-option-history/components/quantity-container/QuantityContainer';

export const APoint = () => {
  const [transactionsObject, setTransactionsObject] = useState<AccountBalanceEntriesResponse | null>(null);

  const fetchTransactions = () => {
    InternalOptionsApi.getTransactionHistory(AccountBalanceAccountType.Ampoints as AccountBalanceAccountType, {
      entryType: EntryType.All as AccountBalanceEntryEntryTypeEnum,
      pageNumber: 1,
    })
      .then(({ transactionDetails }) => {
        transactionDetails && setTransactionsObject(transactionDetails);
      })
      .catch(() => {
        // setShowErrorCard(true);
      });
  };

  useEffect(() => {
    fetchTransactions();
  }, []);

  return (
    <QuantityContainer
      amount={Number(transactionsObject?.totalBalance || 0)}
      expiringPoints={transactionsObject?.expiringPoints}
      expiringDate={transactionsObject?.expiringDate}
      paymentMethodId={PaymentMethodId.AmwayPoints}
    />
  );
};
